import { useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { CompanyComment } from "@/types";

/**
 * This hook is used to add a new company comment to the company comments query
 * without refetching the entire query.
 */
export const useAddCompanyComment = () => {
  const currentCompanyId = useCurrentCompanyId();
  const queryClient = useQueryClient();

  return ({ companyCommentToAdd }: { companyCommentToAdd: CompanyComment }) => {
    queryClient.setQueryData(
      ["company-comments", currentCompanyId],
      (cachedData: CompanyComment[]) => {
        // Important to add the new company comment to the top of the list.
        return [companyCommentToAdd, ...cachedData];
      },
    );
  };
};
